export default "__VITE_ASSET__DmkLHO0a__"